<template>
    <div class="statement-of-facts text-xs-left">
        <h4>If the policy is subject to UK Law:</h4>

        <h5 class="underline">Duty of Fair Presentation</h5>

        <p>
            We take this opportunity to remind you that you owe a duty to make a fair presentation of the risk to the
            insurer.  You have a duty to disclose to the insurer every material circumstance which you know or ought
            to know after a reasonable search or which is sufficient to put the insurer on notice that it needs to make
            further enquiries for the purpose of revealing those material circumstances. In addition, you have a duty
            to disclose information in a clear and accessible manner.
        </p>

        <p>
            A circumstance is material if it would influence a prudent insurer’s judgment in determining whether to
            take the risk and, if so, on what terms.
        </p>

        <p>
            Failure to disclose a material circumstance may entitle an insurer to:
        </p>

        <ul>
            <li>
                in some circumstances, avoid the policy from inception and in this event any claims under the policy
                would not be paid;
            </li>

            <li>impose different terms on your cover; and/or</li>

            <li>reduce the amount of any claim payable.</li>
        </ul>

        <p>This duty applies:</p>
            <ul>
                <li>before your cover is placed;</li>

                <li>when it is renewed; and</li>

                <li>at any time that it is varied.</li>
            </ul>
        <p/>

        <h4>If the policy is subject to Non-UK Law:</h4>

        <h5 class="underline">Duty of Disclosure</h5>

        <p>
            Please ensure you have disclosed to the insurer all information concerning the subject of this insurance
            which they may be expected to consider important when deciding whether to write this cover and on
            what terms.  This information should be disclosed before your cover is placed, when it is renewed
            and any time that it is varied.  Your policy wording may also provide that information should continue to be
            disclosed for the duration of the policy.  If you are in any doubt about whether something is likely to be
            considered important, we recommend that it is disclosed.  Failure to do so may prejudice your cover and
            any claims under it may not be paid.
        </p>
    </div>
</template>

<script>
    export default {
        name: 'StatementOfFact',
    }
</script>

<style lang="scss" scoped>
 .statement-of-facts {
     .underline {
         text-decoration: underline;
     }
 }
</style>
